var _path, _line, _line2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgModalMealPlate(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 29,
    viewBox: "0 0 27 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.6859 16.7393C24.6852 16.7465 24.6846 16.7528 24.6842 16.7582L24.6859 16.7393ZM24.6859 16.7393C24.6867 16.7282 24.6875 16.7104 24.6886 16.6749C24.6887 16.6709 24.6888 16.6664 24.6889 16.6616C24.6895 16.6433 24.6902 16.6197 24.6912 16.5933C24.6826 16.5875 24.6689 16.5793 24.6483 16.5696C24.5921 16.543 24.5136 16.5192 24.4194 16.5026C24.3334 16.4875 24.2542 16.4818 24.1992 16.48H1.23417C1.11002 16.48 1.03982 16.4957 1.0073 16.506C1.0056 16.5138 1.00403 16.5229 1.00271 16.533C1.51724 22.9613 6.65395 27.9501 12.8469 27.9501C18.9673 27.9501 24.0639 23.0846 24.6832 16.7705L24.6859 16.7393Z",
    fill: "#DCEBFC",
    stroke: "#0D3355",
    strokeWidth: 2
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 20.3464,
    y1: 1.39269,
    x2: 12.2616,
    y2: 12.9424,
    stroke: "#0D3355",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 25.176,
    y1: 6.6749,
    x2: 16.2254,
    y2: 13.3878,
    stroke: "#0D3355",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgModalMealPlate);
export default __webpack_public_path__ + "static/media/modal-meal-plate.c7f1e120.svg";
export { ForwardRef as ReactComponent };